// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"286a63e2","453":"55b2104b"}[chunkId] + ".chunk.js";
};